module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar"
  }, [_c('div', {
    staticClass: "avatar__body"
  }, [(_vm.photo) ? _c('img', {
    staticClass: "avatar__img",
    attrs: {
      "src": _vm.photo,
      "alt": "Изображение"
    }
  }) : _c('ChildrenAvatarStub', {
    staticClass: "avatar__img",
    attrs: {
      "gender": _vm.gender
    }
  })], 1), (_vm.isIndicator) ? _c('Indicator', {
    attrs: {
      "isPositive": _vm.isApproved,
      "tooltipText": _vm.tooltipText
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f484118","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/Avatar.vue
// module id = eb55cf38d7dacd93ab01
// module chunks = 89